module.exports = __webpack_public_path__ + "img/eEDA_badge_white.7a929604.png";